import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useMemo } from "react";
import moment from "moment";

const categorizeAgeData = (ageData) => {
  const ageGroups = {
    "0-10": 0,
    "11-20": 0,
    "21-30": 0,
    "31-40": 0,
    "41-50": 0,
    "51-60": 0,
    "61-70": 0,
    "71-80": 0,
    "81+": 0,
  };

  ageData.forEach(({ age }) => {
    if (age <= 10) ageGroups["0-10"]++;
    else if (age <= 20) ageGroups["11-20"]++;
    else if (age <= 30) ageGroups["21-30"]++;
    else if (age <= 40) ageGroups["31-40"]++;
    else if (age <= 50) ageGroups["41-50"]++;
    else if (age <= 60) ageGroups["51-60"]++;
    else if (age <= 70) ageGroups["61-70"]++;
    else if (age <= 80) ageGroups["71-80"]++;
    else ageGroups["81+"]++;
  });

  return ageGroups;
};

const filterAgeDataByTimeframe = (ageData, value) => {
  const now = moment();

  return ageData.filter(({ createdAt }) => {
    const createdMoment = moment(createdAt);
    if (value === "Today") {
      return createdMoment.isSame(now, "day");
    } else if (value === "Last 7 Days") {
      return createdMoment.isSameOrAfter(now.subtract(7, "days"), "day");
    } else if (value === "Last 30 Days") {
      return createdMoment.isSameOrAfter(now.subtract(30, "days"), "day");
    } else {
      return true;
    }
  });
};

const PatientsAgeChart = ({ ageData, value }) => {
  const filteredAgeData = useMemo(
    () => filterAgeDataByTimeframe(ageData, value),
    [ageData, value]
  );

  const { categories, data } = useMemo(() => {
    const ageGroups = categorizeAgeData(filteredAgeData);
    return {
      categories: Object.keys(ageGroups),
      data: Object.values(ageGroups),
    };
  }, [filteredAgeData]);

  const options = {
    chart: {
      type: "column",
      backgroundColor: "#fff",
      borderRadius: 14,
      height: 125,
      width: 350,
      style: {
        fontFamily: "'Arial', sans-serif",
      },
    },
    title: {
      text: "",
      style: {
        fontSize: "14px",
        color: "#333",
      },
    },
    xAxis: {
      categories,
      labels: {
        style: {
          color: "#474747",
          fontSize: "10px",
        },
      },
      lineColor: "#333",
      tickColor: "#333",
    },
    yAxis: {
      title: {
        text: "",
      },
      labels: {
        style: {
          color: "#474747",
          fontSize: "10px",
        },
      },
      gridLineColor: "#fff",
    },
    series: [
      {
        name: "Patients",
        data: data,
        color: "#C3B9D8",
        borderRadius: 5,
      },
    ],
    tooltip: {
      shared: true,
      crosshairs: true,
      formatter: function () {
        return `${this.x}<br/>Patients: ${this.y}`;
      },
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      borderColor: "#ccc",
      style: {
        color: "#333",
        fontSize: "12px",
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
  };

  return (
    <div className="p-4 w-99">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default PatientsAgeChart;
